/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  SyncOrgCustomFieldsToProductsMutationResponse,
  SyncOrgCustomFieldsToProductsQueryParams,
} from "../types/SyncOrgCustomFieldsToProducts.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const syncOrgCustomFieldsToProductsMutationKey = () =>
  [{ url: "/v1/custom-field/sync-org-custom-fields-to-products" }] as const

export type SyncOrgCustomFieldsToProductsMutationKey = ReturnType<
  typeof syncOrgCustomFieldsToProductsMutationKey
>

/**
 * @summary Sync organization custom fields to products
 * {@link /v1/custom-field/sync-org-custom-fields-to-products}
 */
export async function syncOrgCustomFieldsToProducts(
  params: SyncOrgCustomFieldsToProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SyncOrgCustomFieldsToProductsMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "PUT",
    url: `/v1/custom-field/sync-org-custom-fields-to-products`,
    params,
    ...requestConfig,
  })
  return res
}

export function syncOrgCustomFieldsToProductsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = syncOrgCustomFieldsToProductsMutationKey()
  return mutationOptions<
    ResponseConfig<SyncOrgCustomFieldsToProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: SyncOrgCustomFieldsToProductsQueryParams },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return syncOrgCustomFieldsToProducts(params, config)
    },
  })
}

/**
 * @summary Sync organization custom fields to products
 * {@link /v1/custom-field/sync-org-custom-fields-to-products}
 */
export function useSyncOrgCustomFieldsToProducts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<SyncOrgCustomFieldsToProductsMutationResponse>,
      ResponseErrorConfig<Error>,
      { params: SyncOrgCustomFieldsToProductsQueryParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? syncOrgCustomFieldsToProductsMutationKey()

  const baseOptions = syncOrgCustomFieldsToProductsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<SyncOrgCustomFieldsToProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: SyncOrgCustomFieldsToProductsQueryParams },
    TContext
  >

  return useMutation<
    ResponseConfig<SyncOrgCustomFieldsToProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: SyncOrgCustomFieldsToProductsQueryParams },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<SyncOrgCustomFieldsToProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: SyncOrgCustomFieldsToProductsQueryParams },
    TContext
  >
}
